import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Toaster } from "@workspace/ui/components/sonner";
import type { orpc } from "@/api/orpc";
import { NavigationProgress } from "@/components/navigation-progress";
import { GeneralError } from "@/features/errors/general-error";
import { NotFoundError } from "@/features/errors/not-found-error";

type Context = {
  queryClient: QueryClient;
  orpc: typeof orpc;
};

export const Route = createRootRouteWithContext<Context>()({
  context: () => {
    return { isDashboard: true };
  },
  component: () => {
    return (
      <>
        <NavigationProgress />
        <Outlet />
        <Toaster duration={5000} />
        {import.meta.env.MODE === "development" && (
          <>
            <ReactQueryDevtools buttonPosition="bottom-left" />
            {/* <TanStackRouterDevtools position="bottom-left" /> */}
            {/* <TanStackDevtools plugins={[FormDevtoolsPlugin()]} /> */}
          </>
        )}
      </>
    );
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
});
